/** Small formatting helpers for the reporting surfaces. NZ English. */

/** Proportion (0–1) → whole-number percentage string, e.g. 0.475 → "48%". */
export function pct(value: number): string {
  return `${Math.round(value * 100)}%`;
}

/** Proportion (0–1) → one-decimal percentage, e.g. 0.475 → "47.5%". */
export function pct1(value: number): string {
  return `${(value * 100).toFixed(1)}%`;
}

/** Signed percentage-point delta, e.g. +37. */
export function deltaPp(from: number, to: number): string {
  const d = Math.round((to - from) * 100);
  return `${d > 0 ? "+" : ""}${d}`;
}
